import checkReferenceHooks from "./references/check-reference-hooks";

/**
 *
 * @param {Map<String, any>} stepFnName
 * @param {PropertyWrapperProps | null} parent
 * @param {TriggerProps | null | undefined} trigger
 * @param {OptionsListMapProps} options
 */
const setReference = (stepFnName, parent, trigger, options) => {
  if (!trigger) {
    return;
  }

  const name = /** @type {String} */ (parent?.get("name"));
  const isReference = /^@/.test(name);

  stepFnName.set("is-reference", isReference);

  /**
   * on| hooks
   */
  checkReferenceHooks(stepFnName, options);

  if (!isReference) {
    return;
  }

  stepFnName.set("reference-name", name);
};

export default setReference;
